"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { ChartLine, Cpu, Target, ChevronRight, Share2, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
const competencies = [{
  title: "Webentwicklung",
  description: "Hochperformante, maßgeschneiderte Web-Lösungen, die Ihre Marke digital zum Leben erwecken und Nutzer begeistern.",
  icon: Cpu,
  href: "/Webentwicklung"
}, {
  title: "IT-Dienstleistungen",
  description: "Zuverlässige Systembetreuung und proaktive Wartung für eine reibungslose digitale Infrastruktur in Ihrem Unternehmen.",
  icon: Target,
  href: "/IT-Dienstleistungen"
}, {
  title: "KI-Automatisierung",
  description: "Intelligente Workflows und KI-gestützte Prozesse, die Ihre Effizienz steigern und Wettbewerbsvorteile sichern.",
  icon: ChartLine,
  href: "/KI-Automatisierung"
}, {
  title: "Digital Marketing",
  description: "Strategische Online-Marketing-Kampagnen, die Ihre Sichtbarkeit erhöhen und qualifizierte Leads generieren.",
  icon: Target,
  href: "/Digital-Marketing"
}, {
  title: "Social Media Management",
  description: "Kreative Content-Strategien und aktives Community-Management für eine starke Präsenz in sozialen Netzwerken.",
  icon: Share2,
  href: "/Social-Media-Management"
}, {
  title: "Software-Testing",
  description: "Professionelle Softwaretests und Qualitätssicherung für stabile, sichere und fehlerfreie digitale Lösungen.",
  icon: CircleCheck,
  href: "/SoftwareTesting"
}];
export default function OurCoreCompetencies() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222632" id="unsere-expertise" className="bg-background py-24 md:py-32 relative overflow-hidden" ref={sectionRef}>
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/circuit_pattern.png')] opacity-[0.02] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--color-primary)_0%,_transparent_70%)] opacity-10 pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div className={`max-w-3xl mb-16 md:mb-24 transition-all duration-1000 ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-7xl font-bold tracking-tighter mb-6">
            <span className="text-white">Digitale Exzellenz &</span>{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#00E0FF] to-blue-400">
              Zukunftsweisende IT
            </span>
          </h2>
          <p className="text-xl text-muted-foreground font-sans max-w-2xl leading-relaxed">CHROTECH entwickelt moderne digitale Lösungen, die Unternehmen effizienter machen, Prozesse automatisieren und nachhaltiges Wachstum fördern.<div data-ast-id="f:/src/pages/Home/sections/OurCoreCompetencies.tsx|sig:52td4z" data-ast-start="2718" data-ast-end="2853"><br /></div></p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {competencies.map((item, i) => {
          const Icon = item.icon;
          return <div key={item.title} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 200} ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="group h-full flex flex-col bg-card/30 backdrop-blur-xl border-white/10 hover:border-primary/60 hover:bg-card/50 hover:backdrop-blur-2xl transition-all duration-500 overflow-hidden relative rounded-2xl shadow-md hover:shadow-2xl">
                  {}
                  <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-primary to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <CardHeader className="pb-4 pt-8">
                    <div className="mb-6 p-3 bg-primary/10 rounded-lg w-fit text-primary group-hover:scale-110 transition-transform duration-500 ease-out">
                      <Icon size={32} strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-2xl font-bold tracking-tight text-foreground group-hover:text-primary transition-colors duration-300">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="flex-grow pb-8">
                    <CardDescription className="font-sans text-lg text-muted-foreground leading-relaxed">
                      {item.description}
                    </CardDescription>
                  </CardContent>
                  
                  
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}